const getters = {
  unReadNoticeCount: state => state.user.unReadNoticeCount,
  menuCollapse: state => state.app.menuCollapse,
  navigation: state => state.app.navigation,
  authentication: state => state.user.authentication,
  showLoginForm: state => state.user.showLoginForm,
  phases: state => state.user.phases,
  loading: state => state.app.loading,
  progress: state => state.user.progress,
  classes: state => state.admin.classes,
  userTypes: state => state.admin.userTypes
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js